/**
 * 自定义打点
 */
var supported = undefined;
var perf = null;
var uidUniq = Object.create(null);
export function uuid() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}
export function startMeasure(uid) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mark';
  if (!uid) {
    console.warn('[lego]: startMeasure uuid参数为空，已自动生成,请保存');
    uid = uuid();
  }
  if (uid && isSupported()) {
    uidUniq[uid] = true;
    perf.mark("zz-lego-".concat(key, "-").concat(uid));
  }
  return uid;
}
export function endMeasure(uid) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mark';
  if (!uid) return console.warn('[lego]: startMeasure  uuid 参数不能为空');
  if (uidUniq[uid] !== true) return console.warn('[lego]: 请检查 uid 是否存在');
  delete uidUniq[uid];
  if (uid && isSupported()) {
    var startTag = "zz-lego-".concat(key, "-").concat(uid);
    var endTag = startTag + ":end";
    perf.mark(endTag);
    var m = "zz-lego-".concat(key, "<").concat(uid, ">");
    var _perf$measure = perf.measure(m, startTag, endTag),
      duration = _perf$measure.duration;
    perf.clearMarks(startTag);
    perf.clearMarks(endTag);
    perf.clearMeasures(m);
    return duration;
  }
}
export function isSupported() {
  if (supported !== undefined) {
    return supported;
  }
  if (typeof window !== 'undefined' && window.performance) {
    supported = true;
    perf = window.performance;
  } else {
    supported = false;
  }
  return supported;
}